import React from 'react';

import SZJoyride from 'buyside/components/presentation/Joyride/szJoyride';
import { ideaShowJoyrideSteps } from 'buyside/components/presentation/Joyride/IdeaShowJoyride/ideaShowJoyrideHelper';

import { optOutJoyride, shouldHideJoyride } from 'buyside/util/joyrideUtil';

const joyrideCookieName = 'hideIdeaShowJoyride';

const IdeaShowJoyride: React.FC = () => {
  if (shouldHideJoyride(joyrideCookieName)) return null;

  const steps = [ideaShowJoyrideSteps.createQuickPosition];

  return (
    <SZJoyride
      callback={({ status }): void => optOutJoyride(status, joyrideCookieName)}
      disableOverlay
      disableScrolling
      steps={steps}
    />
  );
};

export default IdeaShowJoyride;
